import styled from "styled-components";

export const ContainerDrawyer = styled.div`
  height: 100vh;
  width: 20vw;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 10px #00000029;
  opacity: 1;
`;

export const HeaderBar = styled.div`
  display: flex;
  padding: 30px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font: normal normal 600 20px/30px Montserrat;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  background: #006f35 0% 0% no-repeat padding-box;
  height: 10%;
  width: 100%;
`;

export const NotificationBox = styled.div`
  display: flex;
  align-items: center;
  font: normal normal 600 2vh/2.2vh Open Sans;
  letter-spacing: 0px;
  color: #5f5874;
  opacity: 1;
  width: 100%;
  padding: 10px;
  height: 9%;
  border-bottom: 1px solid #f2f2f2;
`;
